/** Closed multi-select label: one name, or a count when several are selected. */
export function compactMultiSummary(selected, noun = 'selected') {
  const values = Array.isArray(selected) ? selected : [];
  if (values.length === 0) {
    return '';
  }
  if (values.length === 1) {
    return values[0]?.label ?? '';
  }
  return `${values.length} ${noun}`;
}

/** Value shape for chakra-react-select from options + controlled value. */
export function chakraSelectValueForOptions(options, value, isMulti) {
  if (value === undefined || value === null) {
    return null;
  }

  if (isMulti) {
    if (!Array.isArray(value)) {
      return [];
    }
    return options.filter((option) => value.includes(option.value));
  }

  return options.find((option) => option.value === value) ?? null;
}
